import { CONFIG_KEY_BASE, ERROR_DOMAIN_BASE } from "../../constants.js";
const constants_CONFIG_KEY_BASE = `${CONFIG_KEY_BASE}.ab`;
const CONFIG_KEY_REQUEST_ID = `${constants_CONFIG_KEY_BASE}.requestId`;
const CONFIG_KEY_REQUEST_DATE = `${constants_CONFIG_KEY_BASE}.requestDate`;
const CONFIG_KEY_STATUS = `${constants_CONFIG_KEY_BASE}.status`;
const CONFIG_KEY_EXPERIMENTS = `${constants_CONFIG_KEY_BASE}.experiments`;
const constants_ERROR_DOMAIN_BASE = `${ERROR_DOMAIN_BASE}.ab`;
var constants_EStatus = /*#__PURE__*/ function(EStatus) {
    EStatus["Success"] = "success";
    EStatus["Error"] = "error";
    return EStatus;
}({});
export { CONFIG_KEY_EXPERIMENTS, CONFIG_KEY_REQUEST_DATE, CONFIG_KEY_REQUEST_ID, CONFIG_KEY_STATUS, constants_ERROR_DOMAIN_BASE as ERROR_DOMAIN_BASE, constants_EStatus as EStatus };
